import { css } from '@emotion/core';
import {
  DESKTOP_START_QUERY,
  DESKTOP_MEDIUM_START_QUERY,
  DESKTOP_LARGE_START_QUERY,
} from './responsive';

export const BasisFont = css`
  font-family: 'Basis Grotesque', 'Basis', 'sans-serif';
`;

export const PlantinFont = css`
  font-family: 'Plantin', 'serif';
`;

export const mediumWeight = css`
  font-weight: 500;
`;

export const fontSizeStandard = css`
  font-size: 0.875rem;
`;

export const fontSizeSmall = css`
  font-size: 0.75rem;
`;

export const smallLetterSpacing = css`
  letter-spacing: 0.125rem;
`;

export const list = css`
  ${fontSizeSmall}
  line-height: 1.2rem;
  margin-bottom: 1rem;
  padding: 0 0 0 1rem;

  @media (${DESKTOP_MEDIUM_START_QUERY}) {
    ${fontSizeStandard};
    margin-bottom: 1.5rem;
  }
`;

export const paragraphXSmall = css`
  ${fontSizeSmall}
  line-height: 1rem;
  margin-bottom: 0;
  margin-top: 0;

  @media (${DESKTOP_MEDIUM_START_QUERY}) {
    ${fontSizeStandard};
    line-height: 1.25rem;
  }
`;

export const paragraphSmall = css`
  ${fontSizeStandard};
  line-height: 1.25rem;
  margin-bottom: 0;
  margin-top: 0;

  @media (${DESKTOP_MEDIUM_START_QUERY}) {
    font-size: 1rem;
    line-height: 1.5rem;
  }
`;

export const paragraph = css`
  font-size: 1rem;
  line-height: 1.5rem;
  margin-bottom: 1em;
  margin-top: 0;

  @media (${DESKTOP_MEDIUM_START_QUERY}) {
    font-size: 1.25rem;
    line-height: 2rem;
  }
`;

export const paragraphLarge = css`
  font-size: 1.25rem;
  line-height: 2rem;
  margin-bottom: 1em;
  margin-top: 0;

  @media (${DESKTOP_START_QUERY}) {
    font-size: 1.5rem;
    line-height: 2rem;
  }
`;

//Heading styles

export const headingXSmall = css`
  ${BasisFont};
  ${fontSizeStandard};
  font-weight: 500;
  line-height: 1rem;
  margin: 0.5em 0;

  @media (${DESKTOP_START_QUERY}) {
    font-size: 1rem;
    line-height: 1.25rem;
  }
`;

export const headingSmall = css`
  ${BasisFont};
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.25rem;
  margin: 0.75em 0;

  @media (${DESKTOP_START_QUERY}) {
    font-size: 1.25rem;
    line-height: 1.5rem;
  }

  @media (${DESKTOP_LARGE_START_QUERY}) {
    font-size: 1.5rem;
    line-height: 1.75rem;
  }
`;

export const headingMedium = css`
  ${BasisFont};
  font-size: 1.25rem;
  font-weight: 400;
  line-height: 1.5rem;
  margin: 0.5em 0;

  @media (${DESKTOP_START_QUERY}) {
    font-size: 1.5rem;
    line-height: 1.75rem;
  }

  @media (${DESKTOP_LARGE_START_QUERY}) {
    font-size: 2.25rem;
    line-height: 2.5rem;
  }
`;

export const headingLarge = css`
  ${BasisFont};
  font-size: 1.5rem;
  font-weight: 400;

  line-height: 1.75rem;
  margin: 0.5em 0;

  @media (${DESKTOP_START_QUERY}) {
    font-size: 2rem;
    line-height: 2.25rem;
  }

  @media (${DESKTOP_LARGE_START_QUERY}) {
    font-size: 2.5rem;
    line-height: 3rem;
  }
`;

export const headingXLarge = css`
  ${BasisFont};
  font-size: 2rem;
  font-weight: 400;

  line-height: 2.25rem;
  margin: 0.5em 0;

  @media (${DESKTOP_START_QUERY}) {
    font-size: 2.5rem;
    line-height: 2.75rem;
  }

  @media (${DESKTOP_MEDIUM_START_QUERY}) {
    font-size: 3rem;
    line-height: 3rem;
  }
`;

export const trackedStyles = css`
  ${BasisFont};
  font-size: 10px;
  font-weight: 600;
  letter-spacing: 0.166em;
  line-height: 12px;
  margin: 0.5em 0;

  text-transform: uppercase;

  @media (${DESKTOP_START_QUERY}) {
    font-size: 12px;
    line-height: 16px;
  }
`;

export const linkStyles = css`
  ${trackedStyles};
  border-bottom: 1px solid #333;
  color: #333;
  cursor: pointer;
  display: inline-block;
  padding-bottom: 2px;
  text-decoration: none;
  text-transform: uppercase;

  &:hover {
    border-color: #777;
    color: #777;
    text-decoration: none;
  }

  @media (${DESKTOP_START_QUERY}) {
    padding-bottom: 4px;
  }
`;

let Typography = {};

Typography.BasisFont = BasisFont;
Typography.fontSizeStandard = fontSizeStandard;
Typography.PlantinFont = PlantinFont;
Typography.mediumWeight = mediumWeight;
Typography.paragraphXSmall = paragraphXSmall;
Typography.paragraphSmall = paragraphSmall;
Typography.paragraph = paragraph;
Typography.paragraphLarge = paragraphLarge;
Typography.headingXSmall = headingXSmall;
Typography.headingSmall = headingSmall;
Typography.headingMedium = headingMedium;
Typography.headingLarge = headingLarge;
Typography.headingXLarge = headingXLarge;
Typography.trackedStyles = trackedStyles;
Typography.linkStyles = linkStyles;

export default Typography;
